"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function globalSelf() {
    try {
        if (typeof self !== 'undefined') {
            return self;
        }
    }
    catch (e) { }
    try {
        if (typeof window !== 'undefined') {
            return window;
        }
    }
    catch (e) { }
    try {
        if (typeof global !== 'undefined') {
            return global;
        }
    }
    catch (e) { }
    return Function('return this')();
}
exports.globalThisPolyfill = globalSelf();



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/shared/lib/global.js
// module id = 2032
// module chunks = 0